export default {
  showPreview: 'Pokaż podgląd sygnału',
  hidePreview: 'Ukryj podgląd sygnału',
};
